import { t } from "@lingui/macro";
import graphql from "babel-plugin-relay/macro";
import { useFragment } from "react-relay";

import { Button } from "@whoosh/design-system/src/components/controls";
import { LoadingSpinner } from "@whoosh/design-system/src/components/display/Loader/LoadingSpinner";

import { JoinBookingButton_Booking$key } from "./__generated__/JoinBookingButton_Booking.graphql";
import { useJoinBookingAction } from "./hooks/useJoinBookingAction";

type Props = {
  bookingRef: JoinBookingButton_Booking$key | null;
};

export const JoinBookingButton = ({ bookingRef }: Props) => {
  const booking = useFragment(JoinBookingButtonFragmentString, bookingRef);
  const { joinBooking, isJoining } = useJoinBookingAction(booking?.id ?? "");

  if (booking?.writeAccess !== "JOIN") return null;

  return (
    <Button
      accessibilityLabel={t`Join Booking button`}
      testID="join-booking-button"
      size="small"
      isDisabled={isJoining}
      onPress={joinBooking}
    >
      {isJoining ? <LoadingSpinner /> : t`Join Booking`}
    </Button>
  );
};

export const JoinBookingButtonFragmentString = graphql`
  fragment JoinBookingButton_Booking on Booking {
    id
    writeAccess
  }
`;
